import { get } from './index';

export const getPayments = () => {
  return get(`payments`);
};
